export default __webpack_public_path__ + "app/assets/images/job_offer/thumbnail-composite-5d08ca75bd955ffa71a7a42e9cdf4f8a.jpg";